import {
	EnhancedDropDownRHFWithLabel,
	ITest,
	LabelPosition,
} from "@websential/cosmic-v20";
import { FC, useState } from "react";

// import { RHookFormDatePicker } from "../../RHookFormDatePicker";

interface IEmployeeAdvanceInfoFieldsPanel extends ITest {
accountSettingsDDL:any;
}
export const EmployeeAdvanceInfoFieldsPanel: FC<
	IEmployeeAdvanceInfoFieldsPanel
> = ({ accountSettingsDDL }) => {
	
	return (
		<>
			<EnhancedDropDownRHFWithLabel
				label="Terms or Payment Account"
				selectName="termsOrPaymentAccount"
				testId="term-or-payment-account"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
			<EnhancedDropDownRHFWithLabel
				label="Advance"
				selectName="advance"
				testId="advance"
				labelPosition={LabelPosition.Top}
				items={accountSettingsDDL ?? []}
				labelColumns={4}
				fieldColumns={8}
				showEmpty
			/>
		</>
	);
};
